import backend from '@common/backend';

const BASE = '/academicProducts';

export const getAcademicProducts = async (query?: any) => backend.get(`${BASE}/`, {
	params: query,
});

export const getAcademicProduct = async (academic_product_id: number) => backend.get(`${BASE}/${academic_product_id}`);

export const postAcademicProduct = async (data: any) => backend.post(`${BASE}`, data);

export const deleteAcademicProduct = async (academic_product_id: number) => backend.delete(`${BASE}/${academic_product_id}`);

export const updateAcademicProduct = async (academic_product_id: number, data: any) => backend
	.put(`${BASE}/${academic_product_id}`, data);
